import { areObjectIdsEqual } from 'helpers/idComparison';

export function mergeProtocolIssueIds(
  existing: string[],
  incoming: string[]
): string[] {
  const merged = [...existing];
  for (const id of incoming) {
    if (!merged.some((existingId) => areObjectIdsEqual(existingId, id))) {
      merged.push(id);
    }
  }
  return merged;
}

export function areProtocolIssueIdsEqual(
  left: string[],
  right: string[]
): boolean {
  if (left.length !== right.length) {
    return false;
  }
  return left.every((id) =>
    right.some((otherId) => areObjectIdsEqual(id, otherId))
  );
}
